import React, { useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { languages } from '../../intl/languages';

const LanguageDropdown = ({
  language,
  onLanguageChange,
  hideMobileMenu,
  handleMobileLanguageDropdown,
  mobileLanguageExpanded,
  version,
}) => {
  const currentLanguage = languages.find((l) => l.iso === language);

  const [languageIso, setLanguageIso] = useState(currentLanguage.iso);
  const [openMFDropdown, setOpenMFDropdown] = useState(false);

  const handleLanguageChange = (iso) => {
    const newLanguage = languages.find((l) => l.iso === iso);
    setLanguageIso(newLanguage.iso);

    if (newLanguage.iso != languageIso) {
      onLanguageChange(iso);
    }

    hideMobileMenu && hideMobileMenu();
  };

  const marathonFotoLanguages = languages.filter(
    (language) => language.iso === 'en' || language.iso === 'fr'
  );

  return (
    <>
      {version === 'Sportograf' && (
        <div
          className={classNames('navigation-bar-item navigation-bar-languages', {
            'dropdown-expanded': mobileLanguageExpanded,
          })}
        >
          <div
            className={`navigation-bar-dropdown-main icon-${languageIso}`}
            onClick={() => handleMobileLanguageDropdown && handleMobileLanguageDropdown()}
          >
            <span /> {languageIso}
          </div>
          <div className="navigation-bar-dropdown">
            {languages.map((language) => (
              <div
                className={`navigation-bar-dropdown-item icon-${language.iso}`}
                key={language.index}
                onClick={() => handleLanguageChange(language.iso)}
              >
                <span /> {language.title}
              </div>
            ))}
          </div>
        </div>
      )}
      {version === 'MarathonFoto' && (
        <li
          className={classNames('header__navigation-item dropdown-mf', {
            open: openMFDropdown,
          })}
          onClick={() => setOpenMFDropdown((current) => !current)}
        >
          <a
            href="javascript:void(0);"
            className="dropdown-toggle"
            data-toggle="dropdown"
            role="button"
            aria-haspopup="true"
            aria-expanded={JSON.stringify(openMFDropdown)}
          >
            {currentLanguage.iso.toUpperCase()}
            <span className="caret" />
          </a>
          <ul className="dropdown-menu">
            {marathonFotoLanguages.map((language) => (
              <li key={language.index} onClick={() => handleLanguageChange(language.iso)}>
                <a>{language.title}</a>
              </li>
            ))}
          </ul>
        </li>
      )}
    </>
  );
};

LanguageDropdown.defaultProps = {
  version: 'Sportograf',
};

LanguageDropdown.propTypes = {
  onLanguageChange: PropTypes.func,
  language: PropTypes.string,
  hideMobileMenu: PropTypes.func,
  handleMobileLanguageDropdown: PropTypes.func,
  mobileLanguageExpanded: PropTypes.bool,
  version: PropTypes.oneOf(['Sportograf', 'MarathonFoto']),
};

export default LanguageDropdown;
